var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InnerScroll',{attrs:{"title":_vm.content.title,"loading":_vm.loading}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.content.body))}})])}
var staticRenderFns = []

export { render, staticRenderFns }